export function readMoreButton(link: string) {
  return {
    text: 'Read More',
    style: 'primary' as const,
    linkType: 'external' as const,
    link,
  };
}
